import * as React from 'react';
import Slider from 'react-slick';
import './index.scss';

interface OwnProps {
    children: React.ReactFragment;
    onInit?: () => void;
}

class SliderComponent extends React.Component<OwnProps> {

    render(): JSX.Element {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            // adaptiveHeight: true,
            // autoplay: true,
            autoplaySpeed: 10000,
            onInit: this.props.onInit
        };
        return (
            <div className="slider-wrapper">
                <Slider {...settings}>
                    { this.props.children }
                </Slider>
            </div>  
        );
    }
}

export default SliderComponent;


// WEBPACK FOOTER //
// ./src/components/layout/Slider/index.tsx